import React from "react"
import { courses } from "../components/assets/data/dummydata"
import { FaBook } from "react-icons/fa"
import { AiFillStar } from "react-icons/ai"
import { NavLink } from "react-router-dom"
import { HiOutlineArrowNarrowRight } from "react-icons/hi"

export const Courses = () => {
  return (
      <>
        <section className='courses bg-[#F3F4F8] py-16 overflow-hidden'>
          <div className='w-4/5 m-auto md:w-11/12'>
            <div className='heading mb-16 text-center md:mb-10'>
              <h1 className='text-3xl font-semibold text-black'>
                Tution Class
              </h1>
              {/* <span className='text-sm mt-2 block'>
              You don't have to struggle alone, you've got our assistance and help.
            </span> */}
            </div>
            <div className='grid grid-cols-3 gap-8 md:grid-cols-1'>
              {courses.map((item) => (
                  <div key={item.id} className='box rounded-lg shadow-shadow1 bg-white'>
                    <div className='images rounded-t-lg relative overflow-hidden h-40 w-full'>
                      <img
                          src={item.coverUrl}
                          alt=''
                          className='rounded-t-lg object-cover w-full h-full transition ease-in-out delay-150 cursor-pointer hover:scale-105 duration-300'
                      />
                      <div className='categ flex gap-4 absolute top-0 m-3'>
                        {/* Category badges can go here */}
                      </div>
                    </div>
                    <div className='text p-3'>
                      <div className='flex justify-between items-center'>
                        <div className='flex items-center'>
                          <FaBook />
                          <span className='text-[14px] ml-2'>{item.count} lessons</span>
                        </div>
                        <div className='flex items-center'>
                          <AiFillStar className='text-orange-500' />
                          <span className='text-[14px] ml-2'>4.50 (2)</span>
                        </div>
                      </div>
                      <h3 className='text-black my-4 font-medium h-10'>{item.title}</h3>
                      <div className='user flex items-center'>
                        <img
                            className='rounded-full'
                            src={item.imageUrl}
                            alt=''
                            width='50px'
                        />
                        <span className='text-[14px] ml-2'>{item.instructor}</span>
                      </div>
                    </div>
                    <div className='flex items-center justify-between border-t border-gray-200 p-3'>
                      <span className='text-sm text-primary'>Join Now</span>
                      <NavLink
                          to='/'
                          className='text-[14px] ml-2 flex items-center text-primary'
                      >
                        Know Details <HiOutlineArrowNarrowRight />
                      </NavLink>
                    </div>
                  </div>
              ))}
            </div>
          </div>
        </section>
      </>
  )
}
